<template>
  <div class="page__container">
    <Header />

    <div class="page__content">
      <slot />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header'

export default {
  name: 'Page',
  components: { Header }
}
</script>

<style lang="scss" scoped>
.page {
  &__container {
    width: 100%;
  }

  &__content {
    margin: 0 auto;
    padding: 12px;
    width: 100%;

    @media only screen and (min-width: 576px) {
      max-width: 540px;
    }

    @media only screen and (min-width: 768px) {
      max-width: 720px;
    }

    @media only screen and (min-width: 960px) {
      max-width: 960px;
    }

    @media only screen and (min-width: 1264px) {
      max-width: 1264px;
    }

    @media only screen and (min-width: 1904px) {
      max-width: 1600px;
    }
  }
}
</style>
